import React, { useEffect, useState,useContext } from 'react';
import { toast } from 'react-toastify';
import { FormContextProvider } from '@stormwater-software/lib-form';
import GroupModal from './GroupModal';
import {tenantDoctypeGroupsApi} from '../../../utils/api/doctypeGroups';
import AppContext from '../../../contexts/AppContext';
import {tenantDocTypesApi} from '../../../utils/api/docTypes';

const GroupsTab = () => {

  const [groups, setGroups] = useState<any[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [availableFolders, setAvailableFolders] = useState<any[]>([]);
  const appStore = useContext(AppContext);
  const user = appStore.get('user');


  const fetchTenantDocumentGroups = async () => {
      try {

        const response = await tenantDoctypeGroupsApi.get(user.tenantId);

        for(let i=0;i<response.length;i++){

          const groupTenantItems = response[i].tenant_group_items.filter((data:any) => !['Fixed Details', 'Fixed Details Project','Active Site Maps'].includes(data.doc_type?.name));

          response[i].tenant_group_items = groupTenantItems;
        }

        if (response) {
          setGroups(response);
        }


      } catch (error) {
        console.error('Error fetching document groups:', error);
        toast.error('Failed to load document groups');
      }
    };

      const fetchTenantFolders = async () => {
          try {
            const response = await tenantDocTypesApi.get(user.tenantId);
    
            if (response) {
              const folderNames = response.map((data:any) => data.doc_type);
    
             setAvailableFolders([...folderNames]);
            }
    
          } catch (error) {
            console.error('Error fetching system folders:', error);
            toast.error('Failed to load system folders');
          }
        };

  useEffect(() => {   
    fetchTenantDocumentGroups();
    fetchTenantFolders()

  }, []);

  const [selectedGroup, setSelectedGroup] = useState<{
    id: number;
    name: string;
    folders: {  doc_type_id: number; name: string, sort_order:number }[];
  } | null>(null);

  const handleCreateNewGroup = () => {
    setIsEdit(false);
    setSelectedGroup(null);
    setShowModal(true);
  };

  const handleEditGroup = (group: { id: number; name: string; tenant_group_items: { doctype:{name: string,id:number } }[] }) => {
    setIsEdit(true);

    const formattedFolders = group.tenant_group_items.map((item:any) => ({
      doc_type_id: item.doc_type.id,
      name: item.doc_type.name,
      sort_order: item.sort_order
    }));

    setSelectedGroup({
      id: group.id,
      name: group.name,
      folders: formattedFolders
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsEdit(false);
    setSelectedGroup(null);
  };

  const handleSubmitGroup = async (groupData: {
    id?: number;
    name: string;
    folders: {  doc_type_id: number; name: string, sort_order:number }[]
  }) => {
    if (isEdit && groupData.id) {
      await tenantDoctypeGroupsApi.update(user.tenantId, groupData.id.toString(), {
        name: groupData.name,
        folders: groupData.folders
      });

      fetchTenantDocumentGroups();
     
      toast.success('Group updated successfully');
    } else {

      await tenantDoctypeGroupsApi.create(user.tenantId, {
        name: groupData.name,
        folders: groupData.folders
      });

      fetchTenantDocumentGroups();     
      toast.success('Group created successfully');
    }
    handleCloseModal();
  };

  const handleDeleteGroup = async (groupId: number) => {

    await tenantDoctypeGroupsApi.delete(user.tenantId, groupId.toString());

    await fetchTenantDocumentGroups();

    toast.success('Group deleted successfully');
    handleCloseModal();
  };

  return (
    <>
      <div className='groups-tab'>
        {groups.map((group) => (
          <div key={group.id} className='group-card'>
            <div className='group-header'>
              <h4 className='group-name'>{group.name}</h4>
              <div className='group-actions'>
                <button
                  className='action-icon edit-icon'
                  onClick={() => handleEditGroup(group)}
                  title='Edit'
                >
                  <i className='fa fa-pencil' aria-hidden='true' />
                </button>
              </div>
            </div>
            <p className='group-folders'>{group.tenant_group_items?group.tenant_group_items.map((folder:any) => folder.doc_type.name).join(', '):'No folders'}</p>
          </div>
        ))}
        <button className='create-button' onClick={handleCreateNewGroup}>
          <span className='plus-icon'>+</span>
          Create New Group
        </button>
      </div>

      {showModal && (
        <FormContextProvider>
          <GroupModal
            show={showModal}
            isEdit={isEdit}
            group={selectedGroup}
            onClose={handleCloseModal}
            onSubmit={(groupData) => handleSubmitGroup(groupData)}
            onDelete={handleDeleteGroup}
            availableFolders={availableFolders}
          />
        </FormContextProvider>
      )}
    </>
  );
};

export default GroupsTab;
